import {
  addDoc,
  collection,
  doc,
  getDoc,
  getDocs,
  orderBy,
  query,
  updateDoc,
} from "firebase/firestore";
import { db } from "../firebase/firebase";

export const CONTENT_STATUS = {
  DRAFT: "Entwurf",
  REVIEW: "Prüfung",
  PUBLISHED: "Veröffentlicht",
};

export const CONTENT_CATEGORIES = [
  "Stress",
  "Fokus",
  "Motivation",
  "Schule",
  "Achtsamkeit",
  "Bewegung",
];

function normalizeContentItem(docSnap) {
  return {
    id: docSnap.id,
    ...docSnap.data(),
  };
}

function formatDate(value) {
  if (!value) return "—";
  if (value?.toDate && typeof value.toDate === "function") {
    return value.toDate().toLocaleDateString("de-AT");
  }

  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return "—";
  return parsed.toLocaleDateString("de-AT");
}

export async function fetchTips() {
  const snap = await getDocs(query(collection(db, "tips"), orderBy("updatedAt", "desc")));
  return snap.docs.map((doc) => {
    const item = normalizeContentItem(doc);
    return {
      ...item,
      author: item.author || "Admin",
      updatedAtLabel: formatDate(item.updatedAt),
    };
  });
}

export async function fetchTipById(id) {
  const snap = await getDoc(doc(db, "tips", id));
  if (!snap.exists()) return null;

  const item = normalizeContentItem(snap);

  return {
    ...item,
    author: item.author || "Admin",
    updatedAtLabel: formatDate(item.updatedAt),
  };
}

export async function createTip(data) {
  await addDoc(collection(db, "tips"), {
    ...data,
    updatedAt: new Date().toISOString(),
    author: data.author || "Admin",
  });
}

export async function updateTip(id, data) {
  await updateDoc(doc(db, "tips", id), {
    ...data,
    updatedAt: new Date().toISOString(),
  });
}

export async function fetchChallenges() {
  const snap = await getDocs(
    query(collection(db, "challenges"), orderBy("updatedAt", "desc"))
  );

  return snap.docs.map((doc) => {
    const item = normalizeContentItem(doc);
    return {
      ...item,
      author: item.author || "Admin",
      updatedAtLabel: formatDate(item.updatedAt),
      participants: Number(item.participants || 0),
    };
  });
}

export async function fetchChallengeById(id) {
  const snap = await getDoc(doc(db, "challenges", id));
  if (!snap.exists()) return null;

  const item = normalizeContentItem(snap);

  return {
    ...item,
    author: item.author || "Admin",
    updatedAtLabel: formatDate(item.updatedAt),
    participants: Number(item.participants || 0),
  };
}

export async function createChallenge(data) {
  await addDoc(collection(db, "challenges"), {
    ...data,
    participants: Number(data.participants || 0),
    updatedAt: new Date().toISOString(),
    author: data.author || "Admin",
  });
}

export async function updateChallenge(id, data) {
  await updateDoc(doc(db, "challenges", id), {
    ...data,
    updatedAt: new Date().toISOString(),
  });
}